import { render, staticRenderFns } from "./RoundRobinBracket.vue?vue&type=template&id=78450554&scoped=true&"
import script from "./RoundRobinBracket.vue?vue&type=script&lang=js&"
export * from "./RoundRobinBracket.vue?vue&type=script&lang=js&"
import style0 from "./RoundRobinBracket.vue?vue&type=style&index=0&id=78450554&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78450554",
  null
  
)

export default component.exports